import * as React from 'react'
import Finger from 'ainojs-finger'
import { inject, observer } from 'mobx-react'
import { autorun } from 'mobx'
import isNode from 'is-node'

import isTouchDevice from 'src/helpers/isTouchDevice'

import styles from './Carousel.module.scss'
import { ArrowRightIcon } from '../Icon/Icon'

type Props = {
  children: any
  centeredView?: boolean
  listView?: boolean
  ui?: any
  controls?: boolean
  simulateTouch?: boolean
  hideArrows?: boolean
}

@inject('ui')
@observer
class Carousel extends React.Component<Props> {
  finger: any
  container: any
  slides: any
  controls: any
  disposer: any
  prevButton: any
  nextButton: any

  loopFinger = () => {
    this.finger.run()
    if (typeof window !== 'undefined') {
      window.requestAnimationFrame(this.loopFinger)
    }
  }

  setSlidesPosition = () => {
    const { ui } = this.props
    let index = 0
    if (this.slides && ui && ui.windowWidth) {
      for (let slide of this.slides.children) {
        slide.style.left = `${index * this.container.clientWidth}px`
        index++
      }
    }
  }

  setActiveControl = (index: number) => {
    let count = 0
    if (this.controls) {
      if (this.controls.children.length > 10 && index > 5) {
        this.controls.style.left = `-${index * 18 - 5 * 18}px`
      } else {
        this.controls.style.left = '0'
      }
      for (let control of this.controls.children) {
        control.style.opacity = index === count ? '1' : '0.12'
        count++
      }
    }

    if (this.nextButton) {
      const { ui } = this.props
      const steps = ui.windowWidth < 1024 ? 1 : 4
      this.nextButton.style.opacity = index + steps >= this.slides.childElementCount ? '0' : '1'
    }
    if (this.prevButton) {
      this.prevButton.style.opacity = index === 0 ? '0' : '1'
    }
  }

  goToSlide = (index: number) => {
    if (this.finger) {
      this.finger.animateTo(index)
    }
  }

  nextStep = () => {
    const { ui } = this.props
    const steps = ui.windowWidth < 1024 ? 1 : 5
    if (this.finger.index + steps <= this.slides.childElementCount) {
      this.goToSlide(this.finger.index + 1)
    }
  }

  prevStep = () => {
    if (this.finger.index > 0) {
      this.goToSlide(this.finger.index - 1)
    }
  }

  componentDidMount() {
    const { ui = true, simulateTouch = false } = this.props
    this.disposer = autorun(() => {
      if (!isNode) {
        if (ui && ui.windowWidth) {
          this.setSlidesPosition()
          if (this.finger) {
            this.goToSlide(this.finger.index)
          }
        }
      }
    })

    const options = {
      start: this.props.centeredView ? 1 : 0,
      items: this.slides.childElementCount,
      mouse: simulateTouch ? true : isTouchDevice(),
    }

    this.setSlidesPosition()
    this.finger = Finger(this.container, options)
    this.loopFinger()
    this.setActiveControl(options.start)
    const that = this
    if (this.props.centeredView) {
      this.finger.inner.style.left =
        '-' + this.container.clientWidth * options.start + 'px'
    }
    this.finger.on('change', function (e: any) {
      this.inner.style.left = e.position + 'px'
    })
    this.finger.on('complete', function (e: any) {
      that.setActiveControl(e.index)
    })
  }

  componentWillUnmount() {
    this.finger.destroy()
  }

  render() {
    const {
      children,
      centeredView,
      listView,
      controls = true,
      hideArrows = false,
      simulateTouch = false,
    } = this.props

    const containerClass = centeredView
      ? [styles.container, styles.centered].join(' ')
      : listView
        ? [styles.container, styles.list].join(' ')
        : styles.container

    return (
      <div style={{ position: 'relative', height: '100%' }}>
        <div ref={x => (this.container = x)} className={containerClass}>
          <div ref={x => (this.slides = x)} className={styles.slides}>
            {children}
          </div>
        </div>
        {controls && (
          <div
            className={
              centeredView
                ? styles.controls
                : [styles.controls, styles.productControls].join(' ')
            }
          >
            <div
              ref={x => (this.controls = x)}
              className={styles.controlsInner}
            >
              {children.map((el: any, index: number) => (
                <div onClick={() => this.goToSlide(index)} key={index} />
              ))}
            </div>
          </div>
        )}
        {!isTouchDevice() && !simulateTouch && !hideArrows && (
          <React.Fragment>
            <button
              ref={x => (this.prevButton = x)}
              onClick={this.prevStep}
              className={[styles.arrow, styles.arrowLeft].join(' ')}
            >
              <ArrowRightIcon width={19} height={13} color="#000000" />
            </button>
            <button
              ref={x => (this.nextButton = x)}
              onClick={this.nextStep}
              className={[styles.arrow, styles.arrowRight].join(' ')}
            >
              <ArrowRightIcon width={19} height={13} color="#000000" />
            </button>
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default Carousel
